export default [{"url":"https://luscas-inc-test-0.api.invexerp.io","name":"HQ","port":"6515","isStore":true,"isHQ":true}]